import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import OlCore from '../../../../ol/OlCore';
// Using an ES6 transpiler like Babel
import Slider from 'react-rangeslider';

// To include the default styles
import 'react-rangeslider/lib/index.css';

const RangeSliderStyleDefault = {
  Contain: styled.div`
    position: absolute;
    right: 20px;
    bottom: 20px;
    display: flex;
    flex-direction: column;
    z-index: 2;
    box-sizing: border-box;
    box-shadow: 2px 4px 6px 0px #00000040;
    border-radius: 50px;
    background: #fff;
  `,
  Btn: styled.button`
    position: relative;
    width: 48px;
    height: 52px;
    box-sizing: border-box;
    &:before,
    &:after {
      display: block;
      content: '';
      width: 20px;
      height: 2px;
      background: #414862;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    &:first-child {
      border-bottom: 1px solid #ddd;
      border-radius: 50px 50px 0 0;
      &:before {
        width: 2px;
        height: 20px;
      }
    }
    &:last-child {
      border-top: 1px solid #ddd;
      border-radius: 0 0 50px 50px;
      &:after {
        display: none;
      }
    }
  `,
  Wrap: styled.div`
    position: relative;
    width: 26px;
    height: 65px;
    background: #fff;
    padding: 13px 0;
    margin: 0 auto;
  `,
  LabelList: styled.ul`
    position: absolute;
    right: 70%;
    top: 0;
    display: flex;
    flex-direction: column;
    height: calc(100% - 3px);
    justify-content: space-between;
    align-items: flex-end;
    visibility: hidden;
    opacity: 0;
    transition: 0.3s;
  `,
  LabelItem: styled.li`
    position: relative;
    font-size: 12px;
    background: #fff;
    width: max-content;
    padding: 0 6px;
    text-align: center;
    border-radius: 4px;
    box-sizing: border-box;
    box-shadow: 0 0 3px 5px rgba(0, 0, 0, 0.1);
    border: 1px solid #8bc3c3;
    color: #2d9999;
    font-family: 'Pretendard';
    font-weight: 500;
    &:before {
      content: '';
      position: absolute;
      z-index: 2;
      left: calc(100% - 3px);
      top: 50%;
      transform: translateY(-50%) rotate(135deg);
      border: 3px solid transparent;
      border-left: 3px solid #fff;
      border-top: 3px solid #fff;
    }
    &:after {
      content: '';
      position: absolute;
      left: calc(100% - 4px);
      top: 50%;
      transform: translateY(-50%) rotate(135deg);
      border: 4px solid transparent;
      border-left: 4px solid #2d9999;
      border-top: 4px solid #2d9999;
    }
  `,
  InputWrap: styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: calc(100% - 18px);
    background: #fff;
    padding: 0 4px;
    z-index: 10;
    .rangeslider {
      margin: 0;
      height: 100%;
      background: #ddd;
      box-shadow: none;
      width: 2px;

      .rangeslider__fill {
        background: radial-gradient(90.36% 768.66% at 6.07% 40.62%, #0077a6 0%, #00bea3 100%);
      }
      .rangeslider__handle {
        position: relative;
        width: 20px;
        height: 8px;
        left: -9.5px;
        border-radius: 50px;
        box-sizing: border-box;
        background: radial-gradient(90.36% 768.66% at 6.07% 40.62%, #0077a6 0%, #00bea3 100%);
        transform: translatey(-8px);
        &:after {
          display: block;
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 16px;
          height: 4px;
          border-radius: 50px;
          background: #fff;
        }
      }
    }
  `,
  TickWrap: styled.ul<{ value: string }>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    overflow: hidden;
  `,
  Tick: styled.li`
    width: 24px;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
    flex: 1;
    &:first-child {
      border-top: 1px solid #ddd;
    }
    //&:nth-child(1),&:nth-child(2),&:nth-child(4){border-bottom:1px solid #aaa;width:24px;}
  `,
};

const RangeSliderStyle = {
  ...RangeSliderStyleDefault,
  Contain: styled(RangeSliderStyleDefault.Contain)`
    &:hover {
      ${RangeSliderStyleDefault.LabelList} {
        visibility: visible;
        opacity: 1;
        right: calc(100% + 7px);
      }
    }
  `,
};

const RangeSlider = ({ mapInstance }: { mapInstance?: OlCore }) => {
  const [value, setValue] = useState(8);
  const onChange = (value) => {
    mapInstance?.getMapInstance().getView().setZoom(Number(value));
    setValue(Number(value));
  };

  //+, - 버튼 클릭
  const onPlusMinus = (type: string) => {
    if (type === 'plus' && value < 18) {
      mapInstance
        ?.getMapInstance()
        .getView()
        .setZoom(value + 1);
      setValue(Number(value + 1));
    } else if (type === 'minus' && value > 8) {
      mapInstance
        ?.getMapInstance()
        .getView()
        .setZoom(value - 1);
      setValue(Number(value - 1));
    }
  };

  useEffect(() => {
    mapInstance?.onMoveEnd(() => setValue(Number(mapInstance?.getMapInstance().getView().getZoom())));
  }, [mapInstance]);

  return (
    <RangeSliderStyle.Contain>
      <RangeSliderStyle.Btn type={'button'} onClick={() => onPlusMinus('plus')}></RangeSliderStyle.Btn>
      <RangeSliderStyle.Wrap>
        {/*<RangeSliderStyle.LabelList>*/}
        {/*  <RangeSliderStyle.LabelItem>부동산</RangeSliderStyle.LabelItem>*/}
        {/*  <RangeSliderStyle.LabelItem>거리</RangeSliderStyle.LabelItem>*/}
        {/*  /!*<RangeSliderStyle.LabelItem style={{ marginTop: 28 }}>공장별</RangeSliderStyle.LabelItem>*!/*/}
        {/*  <RangeSliderStyle.LabelItem>동</RangeSliderStyle.LabelItem>*/}
        {/*  <RangeSliderStyle.LabelItem>읍/면</RangeSliderStyle.LabelItem>*/}
        {/*  <RangeSliderStyle.LabelItem>시/군/구</RangeSliderStyle.LabelItem>*/}
        {/*  <RangeSliderStyle.LabelItem>시/도</RangeSliderStyle.LabelItem>*/}
        {/*</RangeSliderStyle.LabelList>*/}
        <RangeSliderStyle.TickWrap value={`${(Number(value) - 8) * 10 - 1}`}>
          <RangeSliderStyle.Tick></RangeSliderStyle.Tick>
          <RangeSliderStyle.Tick></RangeSliderStyle.Tick>
          <RangeSliderStyle.Tick></RangeSliderStyle.Tick>
          <RangeSliderStyle.Tick></RangeSliderStyle.Tick>
        </RangeSliderStyle.TickWrap>
        <RangeSliderStyle.InputWrap>
          <Slider min={8} max={18} step={0.1} onChange={onChange} value={value} orientation="vertical" />
        </RangeSliderStyle.InputWrap>
      </RangeSliderStyle.Wrap>
      <RangeSliderStyle.Btn type={'button'} onClick={() => onPlusMinus('minus')}></RangeSliderStyle.Btn>
    </RangeSliderStyle.Contain>
  );
};

export default RangeSlider;
